import MiniMasonry from 'minimasonry';

window.addEventListener('load', () => {
    const grids = document.querySelectorAll('.projects-wrapper');
    const getWidth = () => {
        if (window.innerWidth >= 2500) {
            return 600;
        }
        if (window.innerWidth >= 1900) {
            return 475;
        }
        if (window.innerWidth >= 1400) {
            return 475;
        }
        if (window.innerWidth >= 768) {
            return 375;
        }

        return 400;
    }
    grids.forEach(grid => {
        const masonry = new MiniMasonry({
            container: grid,
            gutter: window.innerWidth >= 992 ? 30 : 10,
            surroundGutter: false,
            baseWidth: getWidth()
        });

        window.addEventListener('resize', () => {
            masonry.options.gutter = window.innerWidth >= 992 ? 30 : 10;
            masonry.layout();
        });

        grid.classList.remove('hidden')
    });
});
